var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      \r\n      .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    className: "cls-2",
    d: "M74.03,35.75h-38.16c-4.78,0-8.66,3.87-8.66,8.65h0v22.39c0,4.78,3.88,8.66,8.66,8.66h38.16c4.78,0,8.65-3.87,8.65-8.65h0v-22.39c0-4.78-3.87-8.65-8.65-8.65h0M62.81,57.19l-12.22,6.74c-.74.41-1.68.14-2.09-.6-.13-.23-.19-.48-.19-.74v-13.47c0-.85.69-1.54,1.54-1.54.26,0,.51.07.74.19l12.22,6.74c.74.41,1.01,1.34.6,2.09-.14.25-.35.46-.6.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5e6449012249da163b67fd8e18c8e4a0.svg";
export { ForwardRef as ReactComponent };